<template>
  <!-- 极速约单-等待中 -->
  <div v-if="orderInfo" class="waiting-order-wrap">
    <div
      :class="{
        'count-down-wrap': true,
        'has-btn-back': !isSelf
      }"
    >
      <button v-if="!isSelf" class="btn-waiting-page" @click="backCreate">
        返回約單大廳
      </button>
      <count-down
        :total="15"
        prefix="倒計時"
        :timestamp="orderInfo.createTime"
        :showCountdownPopup="showCountdownPopup"
        background="#F06950"
        @now="getNowDiff"
        color="#fff"
        @end="autoCancelOrder"
      />
    </div>
    <div ref="mobileScrollWrap" class="page-container">
      <div class="order-info">
        <button v-if="!isSelf" class="btn-waiting-page" @click="backCreate">
          返回約單大廳
        </button>
        <div class="order-panel">
          <div class="top">
            <div class="left">
              <fps-avatar class="avatar" :src="orderInfo.userAvatarUrl" />
              <div
                class="userlevel-tag"
                :class="`level-${orderInfo.userLevel}`"
              ></div>
              <span v-if="isSelf">我的約單</span>
              <span v-else>約單要求</span>
            </div>
            <div class="right">
              <button
                v-if="isSelf"
                class="btn-waiting-page quick-cancel"
                @click="cancelGrabOrder"
              >
                <i v-if="isLoading" class="el-icon-loading" />
                <span v-else>取消</span>
              </button>
              <!-- 非自己，且是B端用户，可以触发聊天 -->
              <button
                v-else-if="inMasterList"
                class="btn-waiting-page quick-chat"
                @click="chatWithBoss"
              >
                聊一聊
              </button>
            </div>
          </div>
          <div class="text">
            <p class="order-remark">
              <template v-if="orderInfo.hbAmount">🧧</template>
              {{ orderInfo | orderInfoTranslate }}
            </p>
            <p v-if="currentOrderRemark">“{{ currentOrderRemark }}”</p>
          </div>
        </div>
      </div>
      <div class="order-waiting">
        <div class="page-title">
          <h3>
            <template v-if="hasAnswer">
              <span class="color">{{ masterList.length }}</span>
              <span v-if="isSelf">位陪玩師回覆您了，請選擇您心儀的陪玩師</span>
              <span v-else>位陪玩師搶單了，等待選擇中</span>
            </template>
            <template v-else>
              <span v-if="isSelf">陪玩師正在趕來，請稍後...</span>
              <span v-else>陪玩師正在趕來...</span>
            </template>
          </h3>
        </div>
        <div class="page-body">
          <template v-if="orderInfo">
            <div v-if="hasAnswer" class="master-list">
              <div
                v-for="master in masterList"
                :key="master.uuid"
                class="master-item-wrap"
              >
                <QuickOrderMaster
                  :ref="'master' + master.uuid"
                  :master="master"
                  :count="orderInfo.count"
                  :quickMatchUuid="quickMatchUuid"
                  :isSelf="isSelf"
                  :hasNewCoupon="orderInfo.hasNewCoupon"
                  @changeFollow="changeFollow(master, $event)"
                  @openskilldetail="openSkillDetail"
                />
              </div>
              <template v-if="isSelf">
                <div v-if="showButtons" class="load-more-master">
                  <p class="tips">
                    <span>{{ masterList.length }}</span
                    >位陪玩師在等待您的回覆，要選擇哪位呢？
                  </p>
                  <div class="button-wrap">
                    <button class="info-btn" @click="showMore">看更多</button>
                    <button class="primary-btn" @click="scrollPageTop">
                      <span>🎲</span>
                      <span>隨機選1個</span>
                      <img src="~@/assets/images/icon-top-arrow.png" />
                    </button>
                  </div>
                </div>
                <div v-else-if="noMore" class="load-more-master">
                  <p class="tips">
                    <span>{{ masterList.length }}</span
                    >位陪玩師在等待您的回覆，要選擇哪位呢？
                  </p>
                  <div class="button-wrap">
                    <button class="primary-btn" @click="scrollPageTop">
                      <span>🎲</span>
                      <span>隨機選1個</span>
                      <img src="~@/assets/images/icon-top-arrow.png" />
                    </button>
                  </div>
                </div>
                <p v-else-if="pageInfo.hide" class="loading-master"></p>
                <div v-else-if="pageInfo.end" class="load-finish-master">
                  <p class="tips">
                    可參與搶單的陪玩師人數已達上限 ({{
                      orderInfo.maxGrabCount
                    }}位)
                  </p>
                  <div class="button-wrap">
                    <button class="primary-btn" @click="scrollPageTop">
                      <span>🎲</span>
                      <span>隨機選1個</span>
                      <img src="~@/assets/images/icon-top-arrow.png" />
                    </button>
                  </div>
                </div>
                <div v-else class="loading-master">
                  <img src="~@/assets/images/loading-scan.gif" />
                  <span>更多陪玩師正在趕來...</span>
                </div>
              </template>
              <template v-else>
                <div v-if="pageInfo.end" class="loading-master">
                  <span>沒有更多了</span>
                </div>
                <div v-else class="loading-master">
                  <img src="~@/assets/images/loading-scan.gif" />
                  <span>更多陪玩師正在趕來...</span>
                </div>
              </template>
            </div>
            <div v-else class="circle-wrap">
              <div class="loading-circle">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <quick-order-cancel
      :uuid="orderInfo.uuid + ''"
      :open="openCancel"
      @close="openCancel = false"
      @submit="canceled"
      @error="$emit('error', $event)"
    />
    <SkillDetail
      v-model="showSkillDetail"
      :info="skillInfo"
      :quickMatchUuid="quickMatchUuid"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import QuickOrderMaster from './quick-order-master';
import QuickOrderCancel from './quick-order-cancel';
import CountDown from './count-down';
import SkillDetail from '@/components/SkillDetail';

export default {
  name:'QuickOrderWaiting',
  components: {
    QuickOrderMaster,
    QuickOrderCancel,
    CountDown,
    SkillDetail
  },
  filters: {
    sexTranslate(sex) {
      if (sex === 'Female') return '女生';
      if (sex === 'Male') return '男生';
      return '性別不限';
    }
  },
  data() {
    return {
      isLoading: false,
      isSelf: false,
      orderInfo: null,
      countDownTimer: null,
      voice: null,
      timer: null,
      renderMasterCount: 0,
      openCancel: false,
      onCancel: false,
      masterList: [],
      allMasterList: [],
      getMoreClickCount: 1,
      lostTime: 0,
      waitTimes: 180000,
      showSkillDetail: false,
      skillInfo: {}
    };
  },
  props: {
    quickMatchUuid: String,
    onlyVoiceText: String,
    showCountdownPopup: Boolean
  },
  computed: {
    ...mapGetters(['userInfo']),
    hasAnswer() {
      return (
        this.orderInfo &&
        this.orderInfo.grabItemDetailVo &&
        this.orderInfo.grabItemDetailVo.length
      );
    },
    inMasterList() {
      // 自己在抢单列表里
      return (
        this.hasAnswer &&
        this.allMasterList.some(item => {
          return item.userUuid === this.userInfo.uuid;
        })
      );
    },
    gameInfoTranslated() {
      const { gameModelName, gameQuickMatchLevels } = this.orderInfo;
      let str = '';
      if (gameModelName) {
        if (gameModelName === '不限') str += '模式';
        str += gameModelName + '，';
      }
      if (gameQuickMatchLevels) {
        if (gameQuickMatchLevels === '不限') str += '牌位';
        str += gameQuickMatchLevels + '，';
      }
      return str;
    },
    currentOrderRemark() {
      const { onlyVoice, remark, remarkReason = '' } = this.orderInfo;
      let str1 = onlyVoice ? '#' + this.onlyVoiceText : '';
      if (!str1 && !remark) {
        return '';
      } else if (str1 && remark) {
        str1 += '，';
      }
      const str2 = remark ? '#' + remark.replace(/\//g, '#') : '';
      return `${remarkReason || ''}${str1}${str2}`;
    },
    pageInfo() {
      const { grabItemDetailVo, topPageSize, maxGrabCount } = this.orderInfo;
      const total = grabItemDetailVo ? grabItemDetailVo.length : 0;
      const size = topPageSize;
      const max = maxGrabCount;
      const now = this.masterList.length;
      const nowTotal = this.renderMasterCount;
      const hide = total < size;
      const showButtons = !hide && nowTotal % size === 0 && now === nowTotal;
      const end = now >= max;
      return { hide, showButtons, end };
    },
    noMore() {
      if (
        !this.pageInfo.end &&
        !this.showButtons &&
        this.lostTime >= this.waitTimes
      ) {
        return true;
      }
      if (
        this.lostTime < this.waitTimes &&
        this.allMasterList.length >= this.orderInfo.topPageSize
      ) {
        return true;
      }
      return false;
    },
    showButtons() {
      if (!this.allMasterList.length) return false;
      if (this.pageInfo.end) return false;
      let count = this.getMoreClickCount * this.orderInfo.topPageSize;
      if (this.allMasterList.length > count) {
        return true;
      }
      return this.lostTime < 0;
    },
    // 取消次數
    cancelCount() {
      if (this.userInfo && this.userInfo.userLevel) {
        if (this.userInfo.userLevel === 13) {
          return 10;
        }
        if (this.userInfo.userLevel === 14) {
          return 15;
        }
        return 3;
      } else {
        return 3;
      }
    }
  },
  created() {
    this.getInitData();
  },
  mounted() {
    if (document.body.clientWidth < 600) {
      document.querySelector('.page-header').style.position = 'fixed';
      // preventScroll()
    }
  },
  beforeDestroy() {
    if (document.body.clientWidth < 600) {
      document.querySelector('.page-header').style.position = 'relative';
      // recoverScroll()
    }
    clearTimeout(this.timer);
    this.timer = null;
  },
  methods: {
    openSkillDetail({ skillInfo }) {
      this.skillInfo = skillInfo;
      this.$util.openWindow(`/player-detail/${skillInfo.uuid}`);
    },
    getInitData() {
      this.$http
        .get('/match/quick/detail', {
          quickMatchUuid: this.quickMatchUuid
        })
        .then(({ data }) => {
          if (!data) {
            this.$emit('error');
            return;
          }
          // data.grabItemDetailVo = [1,2,3,4,5,6,7,8,9,10,11,12,13,14]
          // data.topPageSize = 5
          // data.maxGrabCount = 14
          this.isSelf = this.userInfo && data.userUuid == this.userInfo.uuid;
          this.$emit('setIdentify', this.isSelf);
          if (this.isSelf) {
            if (!this.renderMasterCount) {
              this.renderMasterCount = data.topPageSize;
            }
          } else {
            this.renderMasterCount = data.maxGrabCount;
          }
          this.allMasterList = data.grabItemDetailVo;
          this.masterList = (data.grabItemDetailVo || []).slice(
            0,
            this.renderMasterCount
          );

          if (
            data.grabItemDetailVo &&
            data.grabItemDetailVo.length &&
            (!this.orderInfo ||
              !this.orderInfo.grabItemDetailVo ||
              !this.orderInfo.grabItemDetailVo.length ||
              (this.orderInfo.grabItemDetailVo &&
                data.grabItemDetailVo.length >
                  this.orderInfo.grabItemDetailVo.length))
          ) {
            if (!this.voice) {
              this.voice = document.querySelector('#voice-system');
            }

            if (!this.voice.paused) {
              this.voice.pause();
            }
            this.voice.muted = false;
            this.voice.currentTime = 0;
            this.voice.play();
          }

          this.orderInfo = data;

          // if(this.orderInfo.type === 'PromiseWin') {
          //   this.orderInfo.salesUnit = 'win'
          // }
          if (data.matchStatus === 'Processing') {
            this.timer = setTimeout(this.getInitData, 3000);
          } else if (data.matchStatus === 'Finished') {
            if (data.matchedPlayerUuid == this.userInfo.uuid) {
              // 我被接單
              this.$confirm({
                content: '請盡快接單！被選中不接單，有可能失去搶單資格喔',
                title: '恭喜你，搶單成功！',
                confirmButtonText: '立即接單',
                cancelButtonText: '聊一聊',
                closeOnClickModal: false,
                closeOnPressEscape: false
              })
                .then(() => {
                  this.$router.push('/user/order');
                })
                .catch(() => {
                  this.$emit('finish');
                  this.chatWithBoss();
                });
              return;
            }
            this.$emit('finish');
          } else if (data.matchStatus === 'Cancel') {
            const isSystem = data.cancelUserKind === 'SYSTEM';
            if (this.isSelf) {
              if (isSystem) {
                this.autoCancelOrder();
              } else {
                // debugger;
                this.$emit('finish');
              }
            } else {
              this.$message.error('該訂單已結束');
              this.$emit('finish');
            }
          }
        })
        .catch(err => {
          this.$emit('error', err);
        });
    },
    autoCancelOrder() {
      if (!this.isSelf) {
        this.$message.error(
          this.checkCurrentUserIsJon()
            ? '本次搶單因超時自動取消'
            : '該訂單已結束'
        );
        this.$emit('finish');
        return;
      }
      if (this.onCancel) return;
      this.onCancel = true;
      if (this.openCancel) {
        this.openCancel = false;
      }
      this.$confirm({
        content: `每日取消次數超過${this.cancelCount}次，當日將無法再次進行極速約單喔`,
        title: '您的訂單因超時自動取消',
        confirmButtonText: '知道了',
        showCancelButton: false
      }).then(() => {
        this.$emit('finish');
      });
    },
    cancelGrabOrder() {
      if (this.isLoading) return;
      this.$confirm({
        content: `每日取消次數超過${this.cancelCount}次，當日將無法再次進行極速約單喔`,
        title: '提示',
        confirmButtonText: '知道了',
        showCancelButton: false
      }).then(() => {
        this.openCancel = true;
      });
    },
    canceled() {
      this.$message.success('已取消本次訂單');
      this.$emit('finish');
    },
    scrollPageTop() {
      // if (document.body.clientWidth < 600) {
      //   this.$refs['mobileScrollWrap'].scrollTo(0, 0);
      // } else {
      //   window.scrollTo(0, 0);
      // }
      const randomIndex = Math.floor(Math.random() * this.masterList.length);
      const masterEl = this.$refs['master' + this.masterList[randomIndex].uuid];
      const el = masterEl.length ? masterEl[0] : masterEl;
      el.$el.scrollIntoView({
        block: 'center'
      });
      el.setPreOrder(true);
    },
    showMore() {
      this.getMoreClickCount++;
      const { topPageSize, maxGrabCount } = this.orderInfo;
      this.renderMasterCount = Math.min(
        this.renderMasterCount + topPageSize,
        maxGrabCount
      );
      const nowLength = this.masterList.length;
      this.masterList = this.allMasterList.slice(0, nowLength + topPageSize);
    },
    checkCurrentUserIsJon() {
      const result =
        this.orderInfo.grabItemDetailVo &&
        this.orderInfo.grabItemDetailVo.findIndex(
          item => item.uuid === this.userInfo.uuid
        ) !== -1;
      return result;
    },
    backCreate() {
      this.$emit('finish');
    },
    changeFollow(master, target) {
      master.followed = target;
      clearTimeout(this.timer);
      this.getInitData();
    },
    chatWithBoss() {
      this.$util.openChatWindow(this.userInfo.uuid, this.orderInfo.userUuid);
    },
    getNowDiff(diff) {
      this.lostTime = diff;
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes ldio-lhf4hlfb76p {
  0% {
    transform: scale(0.2);
    opacity: 1;
    box-shadow: 0 0 50px 70px rgba(255, 255, 255, 0.3);
  }
  100% {
    transform: scale(1);
    opacity: 0;
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.1);
  }
}
.btn-waiting-page {
  border: 1px solid #646d7c;
  border-radius: 44px;
  color: rgba(255, 255, 255, 0.7);
  padding: 0 16px;
  height: 28px;
  font-size: 14px;
  transition: background 0.2s;
  &:active,
  &:hover {
    background: #525c6d;
  }
}

.quick-chat {
  border: solid 1px #ffffff;
  color: #ffffff;
}
.page-container {
  .order-info {
    & > .btn-waiting-page {
      margin-bottom: 19px;
    }
    .order-panel {
      background: rgba(255, 255, 255, 0.1);
      box-shadow: 0px 4px 14px rgba(17, 25, 38, 0.18);
      border-radius: 10px;
      padding: 0 15px;
      .btn-waiting-page {
        color: rgba(255, 255, 255, 0.35);
      }
    }
    .top {
      display: flex;
      justify-content: space-between;
      padding: 15px 0 16px;
      font-size: 14px;
      .left {
        position: relative;
        @include flex(flex-start);
        line-height: 28px;
        color: #aab6ca;
        display: flex;
        .avatar {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
        }
        span {
          margin-left: 12px;
        }
      }
      .right {
        line-height: 26px;
      }
    }
    .text {
      color: #8e9aaf;
      font-size: 14px;
      line-height: 20px;
      padding-bottom: 22px;
      p + p {
        margin-top: 2px;
      }
    }
  }
  .order-waiting {
    flex-grow: 1;
    .circle-wrap {
      width: 225px;
      height: 225px;
    }
  }
}

.loading-circle {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
  div {
    position: absolute;
    border-width: 1px;
    border-style: solid;
    opacity: 1;
    border-radius: 50%;
    width: 225px;
    height: 225px;
    opacity: 0;
    transform: scale(0.2);
    transform-origin: center center;
    animation: ldio-lhf4hlfb76p 3s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    &:nth-child(1) {
      border-color: inherit;
    }
    &:nth-child(2) {
      border-color: inherit;
      animation-delay: 1s;
    }
    &:nth-child(3) {
      border-color: inherit;
      animation-delay: 2s;
    }
  }
}

.master-list {
  @include flex(flex-start);
  flex-direction: column;
  .master-item-wrap {
    margin: 16px auto 0;
  }
}

.loading-master {
  @include flex();
  margin-top: 24px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 7px;
  }
  span {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.8);
  }
}

.load-more-master,
.load-finish-master {
  width: 100%;
  margin: 16px auto 0;
  border-radius: 10px;
  padding: 14px 20px;
  box-shadow: 0px 8px 28px rgba(17, 25, 38, 0.18);
  background: rgba(255, 255, 255, 0.1);
  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #fffefd;
  }
}

.load-finish-master {
  @include flex();
  justify-content: space-between;
  p {
    margin-right: 35px;
    font-weight: 500;
  }
  .button-wrap {
    margin-top: 0;
    flex-shrink: 0;
  }
}

.button-wrap {
  @include flex(flex-end);
  margin-top: 12px;
  color: #fffefd;
  button {
    @include flex();
    height: 34px;
    border-radius: 44px;
    line-height: 34px;
    padding: 0 15px;
    font-size: 14px;
  }
}

.info-btn {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.7);
  background: #5a6374;
  margin-right: 12px;
}

.primary-btn {
  background: #fdbe86;
  color: #572e0a;
  font-weight: 500;
  span {
    &:first-child {
      display: inline-block;
      margin-right: 2px;
    }
  }
  img {
    width: 8px;
    height: 10px;
    margin-left: 3px;
  }
}

@media screen and(min-width: 600px) {
  .waiting-order-wrap {
    position: relative;
    width: 980px;
    margin: 0 auto;
    padding-top: 50px;
    .count-down-wrap {
      position: absolute;
      right: 0;
      top: 53px;
      .btn-waiting-page {
        display: none;
      }
    }
    .page-container {
      display: flex;
      align-items: flex-start;
    }
    .order-info {
      width: 339px;
      margin-right: 30px;
      flex-shrink: 0;
    }
    .circle-wrap {
      margin: 80px auto 225px;
    }
  }

  .page-title {
    font-size: 16px;
    line-height: 22px;

    h3 {
      @include flex(flex-start);
      font-size: 0;

      span {
        font-size: 18px;
        line-height: 25px;
        font-weight: 500;
        color: #fff;

        &.color {
          color: #fdbe86;
        }
      }

      img {
        width: 40px;
        height: 40px;
      }
    }

    p {
      color: #666666;
      font-weight: 500;
    }

    .operation {
      @include flex(space-between);

      p {
        @include ellipsis;
        margin-right: 20px;
        opacity: 0.7;
      }
    }

    button {
      @include flex();
      flex-shrink: 0;
      width: 84px;
      height: 26px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #666666;
    }
  }

  .page-body {
    overflow: hidden;
  }

  .master-list {
    padding-bottom: 50px;
    min-height: 540px;
    padding-top: 6px;
    .master-item-wrap {
      width: 100%;
    }
  }
}

@media screen and(max-width: 599px) {
  .waiting-order-wrap {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #323d4f;
    padding-top: 54px;
    overflow: hidden;
    .count-down-wrap {
      flex-shrink: 0;
      padding: 14px 0;
      text-align: center;
      display: flex;
      background: #323d4f;
      width: 90vw;
      margin: 0 auto;
      justify-content: center;
      &.has-btn-back {
        justify-content: space-between;
        padding: 20px 0;
      }
      .btn-waiting-page {
        display: block;
      }
    }
    .page-container {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      .order-waiting {
        display: flex;
        flex-direction: column;
        padding-top: 36px;
        .page-body {
          flex-grow: 1;
          display: flex;
          height: 100%;
          flex-direction: column;
          justify-content: center;
        }
        .circle-wrap {
          margin: 0 auto;
        }
      }
    }
    .order-info {
      width: 90vw;
      margin: 12px auto 0;
      & > .btn-waiting-page {
        display: none;
      }
    }
  }

  .page-title {
    width: 90vw;
    margin: 0 auto;
    font-size: 16px;
    line-height: 22px;
    color: #fff;
    h3 {
      @include flex(flex-start);
      font-size: 0;

      span {
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;

        &.color {
          color: #fdbe86;
        }
      }

      img {
        width: 18px;
        height: 18px;
        line-height: 0;
      }
    }

    p {
      color: #666666;
      font-weight: 500;
    }

    .operation {
      @include flex(space-between);

      p {
        @include ellipsis(2);
        margin-right: 16px;
      }
    }

    button {
      @include flex();
      flex-shrink: 0;
      width: 84px;
      height: 26px;
      border-radius: 4px;
      border: 1px solid #666666;
    }
  }

  .master-list {
    height: 100%;
    padding-bottom: 100px;
    padding-top: 4px;
    .master-item-wrap {
      width: 90vw;
    }
  }

  .load-more-master,
  .load-finish-master {
    width: 90vw;
  }
}
.userlevel-tag {
  position: absolute;
  height: 16px;
  left: -6px;
  bottom: -10px;
}
</style>
